<template class="text-center" v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" class="mb-3" ></spinner>


    <div class="page" v-else-if="loaded" >
        
        <div class="col-12 p-0"  v-if="TITLE != ''" >  <h1 class="h3 font-900" > {{ TITLE }} </h1> </div>
        
        <polar-chart v-if="CHART == 'polar' && CHART_COLUMNS.length > 0" :chart-data="CHART_SERIES" :labels="CHART_COLUMNS" :height="HEIGHT" :symbol="ChartSymbol" ></polar-chart>
        <pie-chart v-else-if="CHART == 'pie' && CHART_COLUMNS.length > 0" :chart-data="CHART_SERIES" :labels="CHART_COLUMNS" :height="HEIGHT" :symbol="ChartSymbol" ></pie-chart>
        
        <div v-else-if="CHART_COLUMNS.length == 0" class="w-100 mt-4 mt-md-5 pt-md-5 text-center position-md-absolute top-0 h-100"  > No data to show </div>
        
        <!-- HANDLE DATA ERROR -->
        <div class="w-100 mt-3 pt-5 text-center position-absolute top-0 h-100" style="background: rgba(255,255,255,0.7)" v-if="error != false" > {{ error }} </div>
        <!-- HANDLE DATA ERROR -->
        
    </div>
</template>

<script>
import {_} from 'vue-underscore';

import pieChart from '@/components/charts/pieChart.js'   
import polarChart from '@/components/charts/polarChart.js'   
import moment from 'moment'    

import helper from '@/helpers/helpers.js';

export default {
    name: 'chartBlock',
    props: {
        data: { 
            type: [Array],
        },
        TITLE:{ type: [String], default: '' },
        SUBTITLE:{ type: [String] },
        HEIGHT:{ type: [Number], default: 90 },
        CHART: { type: [Number, String], default: 'polar' }, // pie / polar
        CHART_COMPONENT: { type: [String], default: 'regular' },
        startDate: { type: [Number, String], default: moment().subtract(1, 'days').startOf('day').unix() },
        endDate: { type: [Number, String], default: moment().endOf('day').unix() },
        symbol: {type: [String], default: ''},
        sumType: {type: [String], default: 'individual'},
        chartOptions: {type: [String, Boolean, Object], default: false },
    },
    components:{
        pieChart,
        polarChart
    },
    data: function(){
        return {
            loaded: false,
            error: false,
            CHART_COLUMNS: [],
            CHART_SERIES: [],
            CHART_SERIES_COMPARE: [],
            CHART_TOTAL: 0,
            CHART_TOTAL_COMPARE: 0,
            ChartSymbol: '',
            CURRENCY: { currency_symbol: '4', currency_symbol_position: 'front' }, 
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        //this.$watch()
    },
    mounted: function () {
        
        //console.log( this.startDate + " " + this.endDate )
        
        let data = this.data
        this.initiate(data)
        
        
    },
    beforeDestroy() {
    },
    methods: {
        initiate(data){
            
            //console.log( this.CHART )
            //console.log(data)
            
            this.loaded = false;
            this.CHART_COLUMNS = []
            
            this.CHART_TOTAL = 0,
            this.CHART_SERIES = []
            
            this.CHART_TOTAL_COMPARE = 0,
            this.CHART_SERIES_COMPARE = []
            
            data.forEach((d)=>{
                                        
                if( d.name != "TOTAL" ){
                    this.CHART_TOTAL += parseFloat( d.orders.length )

                    this.CHART_COLUMNS.push(d.name)
                    this.CHART_SERIES.push(d.orders.length)
                }
                    

            })

            this.loaded = true
        },
        

    },
    computed: {
    },
    watch: {
        'data': function(newVal, oldVal) {
            //console.log('value changed from ' + oldVal + ' to ' + newVal);
            if( oldVal != newVal ){
                this.loaded = false
                this.initiate(newVal)
                
            }
            //console.log( this.CHART_COLUMNS )
            //console.log( this.CHART_SERIES )
            
            //this.chartData.labels = this.CHART_COLUMNS
            //this.chartData.datasets[0].data = this.CHART_SERIES
            
        },
        
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .template-loading{
        margin-top: 50px;
        margin-bottom: 100px;
    }
    
    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/chartBlock-pie.vue